// Copyright (c) 2024. UpCircle Technology AG.
// All rights reserved. Redistribution in source and/or binary forms,
// with or without modification, is not permitted.

import React from "react";
import "./Labeling.scss";

import { AuthContext } from '../../context/AuthContext';
import { firestore, storage } from "../../context/FirebaseConfig";
import { useTranslation } from "react-i18next";

// Importing custom pages
import FullscreenObservationModal from "../../components/FullscreenObservationModal/FullscreenObservationModal";
import LabelingRequests from "../../shared_components/LabelingRequests/LabelingRequests";

export default function LabelingClassicRequested() {
    const { i18n, t } = useTranslation();
    const { currentUser } = React.useContext(AuthContext);
    const [ currentObservation, setCurrentObservation ] = React.useState(null);
    const LabelingRequestHandle = React.useRef(null);

    function getNextObservation() {
        /* Get the next observation */
        LabelingRequestHandle.current.getNextObservation(currentObservation);
    }

    function getPreviousObservation() {
        /* Get the previous observation */
        LabelingRequestHandle.current.getPreviousObservation(currentObservation);
    }

    return (
        <div className="labeling-classic">
            <LabelingRequests
                storage={storage}
                ref={LabelingRequestHandle}
                firestore={firestore}
                currentUser={currentUser}
                currentObservation={currentObservation}
                setCurrentObservation={setCurrentObservation}
                paginationSamples={50}
            />
            {currentObservation && <FullscreenObservationModal 
                observation={currentObservation}
                closeFullscreenModal={() => {setCurrentObservation(false)}}
                getNext={getNextObservation}
                getPrevious={getPreviousObservation}
                showLabelRequest = {false}
            />}
        </div>
    )
}